import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  titleText: {
    marginRight: theme.spacing(2),
  },
}));

export default useStyles;
